import React from 'react';
import {
  maskCrNumber,
  maskMobile,
  maskNameEn,
  maskNameAr,
  maskIdNumber,
  maskLandline,
  HIDDEN_ADDRESS,
} from '../../utils/masking';
import { useAuth } from '../../hooks/useAuth';

type MaskType = 'cr' | 'mobile' | 'nameEn' | 'nameAr' | 'idNumber' | 'landline' | 'address';

interface MaskedFieldProps {
  value: string | null | undefined;
  type: MaskType;
  offerStatus: string;
}

const CLOSED_STATUSES = ['Accepted', 'Rejected'];

const maskFnMap: Record<MaskType, (v: string) => string> = {
  cr: maskCrNumber,
  mobile: maskMobile,
  nameEn: maskNameEn,
  nameAr: maskNameAr,
  idNumber: maskIdNumber,
  landline: maskLandline,
  address: () => HIDDEN_ADDRESS,
};

export const MaskedField: React.FC<MaskedFieldProps> = ({ value, type, offerStatus }) => {
  const { user } = useAuth();
  if (!value) return <span>—</span>;

  const shouldMask =
    user?.role === 'reseller-agent' && CLOSED_STATUSES.includes(offerStatus);

  const display = shouldMask ? maskFnMap[type](value) : value;
  return <span>{display}</span>;
};
